module.exports = __webpack_public_path__ + "img/zip.ec5528bf.svg";